"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPrefixCls = exports.annaPrefix = void 0;
exports.annaPrefix = 'anna';
exports.getPrefixCls = (name) => `${exports.annaPrefix}-${name}`;
